import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { motion } from "framer-motion";

const FinanceOption = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const { clientX, clientY, currentTarget } = e;
    const { left, top, width, height } = currentTarget.getBoundingClientRect();

    // Calculate relative position (-50 to 50 range)
    const x = ((clientX - left) / width - 2) * 20; // Text movement
    const y = ((clientY - top) / height - 1) * 20;

    const bgX = ((clientX - left) / width - 5) * 30; // Background movement
    const bgY = ((clientY - top) / height - 0.5) * 30;

    setPosition({ x, y, bgX, bgY });
  };
  return (
    <>
      <section className='finance-option-wrap'>
        <div className="mouse-container" onMouseMove={handleMouseMove}>
          <motion.div
            className="mouse-background"
            animate={{
              x: position.bgX,
              y: position.bgY,
            }}
            transition={{ type: "tween", stiffness: 50 }}
          />
          <div className='w-100 mouse-text'>
            <div className='container'>
              <h3 className='xxl-title text-center text-uppercase mb-2 wow reveal fadeInUp'>Finance Options</h3>
              <div className='lg-title text-center wow reveal fadeInUp'>Discover our Amazing and Flexible Financing Plans</div>
              <div className='mt-md-5 mt-4 text-center wow reveal fadeInUp'>
                <Link to='/finance' className='black-red-btn w-240 d-inline-block text-uppercase fw-bold'>Learn More</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default FinanceOption